/* eslint-disable consistent-return */
import { useEffect, useState } from 'react'

export default function Search({ doneTyping = true, onChange = () => {} }) {
  const [query, setQuery] = useState('')

  useEffect(() => {
    if (!doneTyping) {
      onChange(query)
      return
    }

    const timer = setTimeout(() => {
      onChange(query)
    }, 250)

    return () => clearTimeout(timer)
  }, [query])

  return (
    <>
      <i className="hb-ico search-ico" />
      <input
        type="search"
        name="search"
        placeholder="Search"
        onChange={(e) => {
          setQuery(e.target.value)
        }}
      />
    </>
  )
}
